export default {
    authNotificationsTotal_zero: 'You have no unread notifications',
    serviceChat: {
        alert_title_closed: 'Chat Closed',
        alert_text_closed: 'This chat is no longer available',
        alert_text_closed_by: 'The chat was closed by {{name}}',
        alert_title_chat_unavailable: 'Chat Unavailable',
        alert_text_chat_unavailable: 'The chat is being answered by another user',

        request: 'The customer <b>{{name}}</b> is waiting to be answered in the <b>Chat</b>',
        request_customer: 'You requested assistance via <b>Chat</b>',
        closed: 'Your <b>Chat</b> was terminated by <b>{{name}}</b>',
        closed_user_agent: 'You have ended your <b>Chat</b> with the client <b>{{name}}</b>',
        closed_user_customer: 'You ended your <b>Chat</b> with the attendant <b>{{name}}</b>',
        canceled_transfer_title: 'Canceled Transfer',
        canceled_transfer_text: 'User canceled chat transfer',
        refused_transfer_title: 'Transfer Declined',
        refused_transfer_text: 'User declined chat transfer',
    },
    call: {
        created: '<b>New Ticket</b> #{{number}} - <b>{{group}}</b> {{- category}} - {{subject}}',
        edited: 'Ticket #{{number}} <b>Edited</b> - <b>{{group}}</b> {{- category}} - {{subject}}',
        archived: '<b>Archived</b> Ticket #{{number}} - <b>{{group}}</b> {{- category}} - {{subject}}',
        sla_limit_exceeded: 'Ticket #{{number}} - <b>{{group}}</b> {{- category}} - <b>SLA Warning ({{percentage}}%)</b>',
        transferred: 'You received <b>{{qnt}}</b> ticket(s) - <b>{{group}}</b> - Transferred from user {{from}}',
    },
    attendance: {
        created: 'Ticket #{{number}} has been <b>answered</b> - <b>{{group}}</b> {{- category}} - {{subject}}',
    },
    task: {
        created: '<b>New Task</b> #{{number}} - <b>{{group}}</b> - {{subject}}',
        edited: 'Task #{{number}} <b>Edited</b> - <b>{{group}}</b> - {{subject}}',
        archived: '<b>Archived</b> Task #{{number}} - <b>{{group}}</b> - {{subject}}',
    },
}
